<template>
  <dl>
    <dt>
      <download-popup v-if="downloadLayout" contenttype="vod" :content-info="contentInfo"
                      :contentid="thumb.contentid" :close="closeDownloadLayout"/>
      <a href="#" @click.prevent="changeContent(thumb)">
        <div class="thumb-image">
          <img v-lazy="getLazyLoadingImageObject(thumb)" class="thumb" alt="" />
          <div class="tag-top tag-list" v-top-tag-list="thumb.top_taglist">
          </div>
          <div v-if="thumb.progress && hasLogin" class="vod-progress">
            <span class="gradation-purple" :style="'width:' + Number(thumb.progress) * 100 + '%;'"></span>
          </div>
        </div>
        <div :class="vodPlayNowClass(thumb)"></div>
      </a>
    </dt>
    <dd>
      <template v-if="!isPooqzone">
        <div>
          <a v-if="thumb.downloadable === 'y'" href="#" @click.prevent="download()" class="download" :title="linkTitle  + ' 다운로드'">
            <img src="../../assets/images/common/ico-download.png" alt="다운로드" />
          </a>
        </div>
      </template>
      <a href="#" @click.prevent="changeContent(thumb)" :title="linkTitle + '로 이동'">
        <div class="sub-right" v-title-list="{'titleList': thumb.title_list}"></div>
        <em ref='synopsis' :class="thumb.holdbackcontent === 'y' ? 'week6-synopsis' : ''" v-if="thumb.synopsis" v-html="synopsis"></em>
        <span v-if="thumb.actors" class="actor"> 출연 : {{ thumb.actors }}</span>
        <span class="week6-text" v-if="thumb.holdbackcontent === 'y'">wavve Lite</span>
      </a>
    </dd>
  </dl>
</template>

<script>
import _ from 'lodash'
import {
  addPostfixAndUrl,
  changeEscapeCharacter,
  goVerifyAdultPageForDownload,
  isAdultContent,
  userAdultVerifiedInfo
} from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import { getVodContentsDetail, getVodProgramsContentid } from '@/common/utils/request'
import DownloadPopup from '@/components/player/PopupDownload'
import { titleList, topTagList } from '@/common/resources/directives'
import { resizeThumbnail } from '@/common/utils/image'
import constant from '@/common/resources/constant'
export default {
  props: {
    thumb: {
      type: Object
    },
    contenttype: {
      type: String
    },
    isPooqzone: {
      type: Boolean
    },
    externalContentId: {
      type: String,
      default: ''
    },
    changeContent: {
      type: Function
    },
    thumbnailInfo: {
      type: Object
    }
  },
  directives: {
    titleList,
    topTagList
  },
  filters: {
    addPostfixAndUrl
  },
  components: {
    DownloadPopup
  },
  data () {
    return {
      contentId: '',
      downloadLayout: false,
      contentInfo: null
    }
  },
  computed: {
    linkUrl () {
      return '/player/vod.html?programid=' + this.thumb.programid + '&contentid=' + this.thumb.contentid
    },
    linkTitle () {
      const titleList = _.get(this.thumb, 'title_list', [])
      const episodeNumberAndDateArray = _.get(titleList, '1.text', 1).split('$O$')
      const episodeNumber = episodeNumberAndDateArray[0].indexOf('회') > -1 ? episodeNumberAndDateArray[0] : episodeNumberAndDateArray[0] + '회'
      const episodeTitle = _.get(titleList, '0.text', '')
      return `${episodeNumber} ${episodeTitle}`
    },
    hasLogin () {
      return cookie.getCredential() !== 'none'
    },
    synopsis () {
      const browserName = window.uaInfo.getBrowser().name
      const synopsis = _.get(this.thumb, 'synopsis', '')
      if (browserName.toUpperCase() === 'IE' && window.uaInfo.getBrowser().major === '10') {
        const splitSynopsis = synopsis.split('<br>')
        const firstSynopsis = splitSynopsis[0]
        return firstSynopsis.length < 45 ? firstSynopsis + '...' : firstSynopsis.substr(0, 45) + '...'
      } else {
        return synopsis
      }
    }
  },
  methods: {
    changeEscapeCharacter,
    url (url) {
      return location.protocol + '//' + url
    },
    download () {
      if (cookie.getCredential() === 'none') {
        window.showLoginLayout()
      } else {
        getVodContentsDetail({ contentid: this.thumb.contentid }).then(async ({ data }) => {
          this.contentInfo = data
          const targetAge = _.get(data, 'targetage', '0')
          const { isAdultVerified, expire } = await userAdultVerifiedInfo()
          if (isAdultVerified) {
            cookie.setItem('verifiedAdult', '1', expire, constant.URL_COOKIE_DOMAIN, '/')
          }
          if (isAdultContent(targetAge) && cookie.isNotVerifiedAdultUser()) {
            goVerifyAdultPageForDownload({ referer: this.$route.fullPath, enter: this.$route.fullPah })
          } else {
            this.downloadLayout = true
          }
        })
      }
    },
    addPostfixAndUrl: addPostfixAndUrl,
    vodPlayNowClass (thumb) {
      return this.contentId === thumb.contentid ? 'vod-play-now' : ''
    },
    closeDownloadLayout () {
      this.downloadLayout = false
      // setDisableScrolling(false) // 윈도우 스크롤 사용
    },
    getLazyLoadingImageObject (thumb) {
      return {
        src: resizeThumbnail(thumb.thumbnail, this.thumbnailInfo),
        error: this.thumbnailInfo.placeholderImage,
        loading: this.thumbnailInfo.placeholderImage
      }
    }
  },
  created () {
    this.contentId = this.externalContentId
    let programId = _.get(this.$route, ['query', 'programid'], '')
    if (this.contentId === '') {
      getVodProgramsContentid({ programid: programId }).then(({ data }) => {
        this.contentId = data.contentid
      })
    }
  }
}
</script>
<style>
  .player-component01 .week6-synopsis{
    display: block;
    height: 22px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
  }
  .player-component01 .week6-text{
    font-size: 14px;
    line-height: 20px;
    color: #fff;
  }
  .vod-play-now:after{
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3) url("../../assets/images/common/ic-now-play.png") center no-repeat;
  }
</style>
